export default __webpack_public_path__ + "static/media/table-search-icon.b38a81bf.svg";